import { cn, Stack, Tooltip, TooltipContent, TooltipTrigger } from 'component-library';
import { useTranslation } from 'react-i18next';

export const ApprovalPill = ({ isApproved, className }: { isApproved: boolean; className?: string }) => {
  const { t } = useTranslation();

  return (
    <Tooltip>
      <TooltipTrigger>
        <Stack
          direction='row'
          spacing={2}
          className={cn(
            'items-center px-2 py-1 rounded-3xl border border-divider typography-body2 text-text-primary',
            isApproved && 'bg-success-light',
            !isApproved && 'bg-warning-light',
            className,
          )}
        >
          <i className={isApproved ? 'ri-checkbox-circle-line' : 'ri-time-line'} />
          <span>
            {isApproved
              ? t('shared.uploadsPlotOverview.plotOverview.labels.approved')
              : t('shared.uploadsPlotOverview.plotOverview.labels.pendingApproval')}
          </span>
        </Stack>
      </TooltipTrigger>
      <TooltipContent>
        {t(
          isApproved
            ? 'shared.uploadsPlotOverview.plotOverview.labels.approvedDescription'
            : 'shared.uploadsPlotOverview.plotOverview.labels.pendingApprovalDescription',
        )}
      </TooltipContent>
    </Tooltip>
  );
};
